import React, {useState} from 'react';
import {Button, Modal} from "antd";

const SupportModal = (props) => {
    return (
        <Modal title="Crate new application"
               open={props.isModalOffice}
               onCancel={() => props.setIsModalOffice(false)}
               footer={[
                   <Button key="submit" type="primary" onClick={props?.createApplication}>
                       Create
                   </Button>,
                   <Button key="submit" type="default" onClick={() => props.setIsModalOffice(false)}>
                       Cancel
                   </Button>
               ]}
        >
            <div className="cam-add-modal">
                <div className="inputs-box">
                    <label className="font-family-medium">Text</label>
                    <textarea onChange={(e) => props?.setText(e?.target?.value)}/>
                </div>
                <div className="inputs-box">
                    <label className="font-family-medium">Image or file </label>
                    <input onChange={(e) => props?.setPic(e)} type="file"/>
                </div>
            </div>

        </Modal>
    );
};

export default SupportModal;